import React, { useState, Fragment } from 'react';
import { SearchOverlay } from './SearchOverlay';
export function Header() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <>
      <header className="w-full bg-white border-b border-light relative z-50" data-id="element-27">
        <div className="site-container py-4 lg:py-6 flex items-center justify-between" data-id="element-28">
          {/* LEFT: Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate - The Marketing and Advertising Resource" className="h-[40px] md:h-[50px] lg:h-[60px] w-auto object-contain" data-id="element-30" />
          </a>

          {/* CENTER: Nav Links */}
          <nav className="hidden xl:flex items-center" data-id="element-31">
            {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map((item, index, array) => <Fragment key={item} data-id="element-32">
                  <a href={`#${item.toLowerCase()}`} className="text-grey text-nav text-upper hover:text-black transition-colors" style={{
              letterSpacing: '0.14em'
            }} data-id="element-33">
                    {item}
                  </a>
                  {index < array.length - 1 && <span className="text-grey text-nav mx-2 lg:mx-4" style={{
              letterSpacing: '0.14em'
            }} data-id="element-34">
                      I
                    </span>}
                </Fragment>)}
          </nav>

          {/* RIGHT: Search & Adweek */}
          <div className="flex items-center gap-4 lg:gap-8" data-id="element-35">
            <button onClick={() => setIsSearchOpen(true)} className="flex items-center justify-center hover:opacity-70 transition-opacity" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/patterns/figma-svgs/qMYA2TKA2kze7CZ7XfjFwj/1058-5.svg" alt="Search" className="w-5 h-5 lg:w-6 lg:h-6" data-id="element-37" />
            </button>

            <div className="hidden xl:flex flex-col items-center justify-center" data-id="element-38">
              <span className="text-grey text-label text-upper mb-1" data-id="element-39">
                In association with
              </span>
              <img src="https://cdn.magicpatterns.com/patterns/figma-images/qMYA2TKA2kze7CZ7XfjFwj/1052-28.png" alt="Adweek" className="h-[40px] lg:h-[50px] w-auto object-contain" data-id="element-40" />
            </div>

            {/* Mobile Menu Toggle */}
            <button className="xl:hidden hover:opacity-70 transition-opacity" onClick={() => setIsMobileMenuOpen(true)} style={{
            color: '#6B6B6B'
          }} data-id="element-41">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" data-id="element-42">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" data-id="element-43" />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen Mobile Menu */}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[100] flex flex-col" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-44">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between px-4 py-4" data-id="element-45">
            <a href="#" className="flex-shrink-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/jXZbuP4JpR1bBw61Qwmybj/com-logo-left.png" alt="Communicate" className="h-[40px] w-auto object-contain" data-id="element-47" />
            </a>
            <button onClick={() => setIsMobileMenuOpen(false)} className="hover:opacity-70 transition-opacity" style={{
          color: '#6B6B6B'
        }} data-id="element-48">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-7 h-7" data-id="element-49">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-50" />
              </svg>
            </button>
          </div>

          {/* Mobile Nav Links */}
          <nav className="flex-1 flex flex-col items-center justify-center gap-8" data-id="element-51">
            {['News', 'Brands', 'Agencies', 'Focus', 'Editions', 'Ranking'].map(item => <a key={item} href={`#${item.toLowerCase()}`} onClick={() => setIsMobileMenuOpen(false)} className="uppercase tracking-widest hover:opacity-70 transition-opacity" style={{
          color: '#6B6B6B',
          fontSize: '20px',
          fontFamily: 'Poppins',
          fontWeight: 700,
          letterSpacing: '0.14em'
        }} data-id="element-52">
                  {item}
                </a>)}
          </nav>

          {/* Mobile Menu Footer */}
          <div className="flex flex-col items-center pb-8 gap-2" data-id="element-53">
            <span className="uppercase" style={{
          color: '#6B6B6B',
          fontSize: '11px',
          letterSpacing: '0.1em'
        }} data-id="element-54">
              In association with
            </span>
            <img src="https://cdn.magicpatterns.com/patterns/figma-images/qMYA2TKA2kze7CZ7XfjFwj/1052-28.png" alt="Adweek" className="h-[40px] w-auto object-contain" data-id="element-55" />
          </div>
        </div>}

      <SearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} data-id="element-56" />
    </>;
}